import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { Validator } from '@adornis/validation/validator.js';
import { type Entgeltart, isTypeWithTariff } from '../../../enums/Entgeltart.js';
import { Lohnart } from '../../../enums/Lohnart.js';
import type { Tarifgruppe } from '../../../enums/Tarifgruppe.js';
import { Zahlung } from '../Zahlung.js';

@Entity()
export class AGLohnGehaltszahlungen extends AdornisEntity {
  static override _class = 'AGLohnGehaltszahlungen';

  @Field(type => String)
  entgeltart: Maybe<Entgeltart>;

  @Field(type => String)
  tarifgruppe: Maybe<Tarifgruppe>;

  @Field(type => Date)
  fiktivBeginnStufe1: Maybe<Date>;

  @Field(type => Int)
  manuelleErfahrungsstufe?: Maybe<number>;

  @Field(type => [Zahlung], { default: v => v ?? [] })
  @validate(options => {
    if (((options.value as Maybe<Zahlung[]>)?.filter(z => z.lohnart === Lohnart.ENTGELT).length ?? 0) > 1)
      throw new ValidationError('Kann maximal eine Zahlung mit Lohnart Entgelt konfigurieren', {
        key: options.key,
        source: options.source,
        target: options.target,
      });
  })
  monatlicheZahlungen: Maybe<Zahlung[]>;
}

if (A.isClient) {
  AGLohnGehaltszahlungen.prototype.validator = new Validator({
    entgeltart: options => (options.simpleValidation ? (() => {})() : nonOptional()(options)),
    tarifgruppe: options => {
      if (isTypeWithTariff(options.target.entgeltart)) return nonOptional()(options);
    },
  });
}
